import { render } from "./ProgressiveLimits.vue?vue&type=template&id=1de4c5be&scoped=true"
import script from "./ProgressiveLimits.vue?vue&type=script&lang=js"
export * from "./ProgressiveLimits.vue?vue&type=script&lang=js"

import "./ProgressiveLimits.vue?vue&type=style&index=0&id=1de4c5be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de4c5be"]])

export default __exports__